import { createContext, useState, useMemo, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

export function CustomThemeProvider({ children }) {
  // Initialiser le mode à partir du localStorage ou par défaut 'light'
  const [mode, setMode] = useState(() => {
    const savedMode = localStorage.getItem('color-mode');
    return savedMode ? savedMode : 'dark';
  });

  // Mettre à jour le localStorage chaque fois que le mode change
  useEffect(() => {
    localStorage.setItem('color-mode', mode);
  }, [mode]);

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [mode]
  );

  const theme = useMemo(() => {
    return createTheme({
      palette: {
        mode,
        ...(mode === 'light'
          ? {
              // Palette pour le mode clair
              background: {
                default: '#f5f5f5',
                paper: '#ffffff',
              },
              text: {
                primary: '#000000',
              },
            }
          : {
              // Palette pour le mode sombre
              background: {
                default: 'linear-gradient(180deg, rgba(2,0,36,1) 0%, rgba(52,5,93,1) 50%, rgba(41,2,104,1) 100%)',
                paper: '#1e1e1e',
              },
              text: {
                primary: '#ffffff',
              },
            }),
      },
      typography: {
        fontFamily: [
          'Poppins',
        ].join(','),
      },
    });
  }, [mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
}
